import { create } from 'zustand';

interface ClaimEditStepperState {
  queue: string[];
  currentIndex: number;
  setQueue: (ids: string[]) => void;
  setCurrentById: (id: string | null) => void;
  next: () => string | null;
  previous: () => string | null;
  clear: () => void;
}

export const useClaimEditStepperStore = create<ClaimEditStepperState>((set, get) => ({
  queue: [],
  currentIndex: -1,
  setQueue: (ids: string[]) => {
    const unique = Array.from(new Set(ids)).filter(Boolean);
    set({
      queue: unique,
      currentIndex: unique.length ? 0 : -1,
    });
  },
  setCurrentById: (id: string | null) => {
    if (!id) {
      set({ currentIndex: -1 });
      return;
    }
    const idx = get().queue.findIndex((claimId) => claimId === id);
    if (idx === -1) {
      set({ queue: [], currentIndex: -1 });
      return;
    }
    set({ currentIndex: idx });
  },
  next: () => {
    const { currentIndex, queue } = get();
    const nextIndex = currentIndex + 1;
    if (nextIndex >= queue.length) return null;
    set({ currentIndex: nextIndex });
    return queue[nextIndex];
  },
  previous: () => {
    const { currentIndex, queue } = get();
    const prevIndex = currentIndex - 1;
    if (prevIndex < 0) return null;
    set({ currentIndex: prevIndex });
    return queue[prevIndex];
  },
  clear: () => set({ queue: [], currentIndex: -1 }),
}));
